import { FC, JSX, useState } from 'react';
import { Property } from '@model';
import { ShareDialogContext, ShareDialogModel } from './ShareDialogContext.ts';

export const ShareDialogProvider: FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [showDialogProperty, setShowDialogProperty] = useState(
    undefined as Property | undefined,
  );

  const model = {
    hideShareDialog: () => setShowDialogProperty(undefined),
    showShareDialog: (property: Property) => setShowDialogProperty(property),
    shareDialogProperty: showDialogProperty,
  } as ShareDialogModel;

  return (
    <ShareDialogContext.Provider value={model}>
      {children}
    </ShareDialogContext.Provider>
  );
};
